// UI strings for "Kertaa uudelleen" on Tänään (lib/redo.ts): another practice round of the day's
// cards, as often as you like. Finnish (default) and English side by side; en has the same shape.
import { defineArea } from '../area';

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export const redoFi = {
  start: 'Kertaa uudelleen',
  /** The round's end: cards gone over, then the extra rounds of cards that came back. */
  end: (cards: number, repeats: number) => `${plural(cards, 'kortti', 'korttia')} kerrattu${repeats ? `, ${plural(repeats, 'uusinta', 'uusintaa')}` : ''}.`,
  /** A lesson word the pace has not introduced yet: its grade is not saved. */
  rehearsalNote: 'Tämä sana ei ole vielä kertauksissasi. Arvio ei tallennu – sana tulee päivän kortteihin, kun sen vuoro tulee.',
  back: 'Takaisin päivän kortteihin',
};

export const redoEn: typeof redoFi = {
  start: 'Review again',
  end: (cards, repeats) => `${plural(cards, 'card', 'cards')} reviewed again${repeats ? `, ${plural(repeats, 'repeat', 'repeats')}` : ''}.`,
  rehearsalNote: 'This word is not in your reviews yet. The grade is not saved – the word joins your daily cards when its turn comes.',
  back: "Back to today's cards",
};

// Messages.redo (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('redo', redoFi, redoEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof redoFi> {}
}
